// src/hooks/useSalonData.ts
import { useState, useEffect } from "react";
import { StylingStaff, Category, SelectProduct } from "../types/salon.types";
import { getCategory, getProduct, getStaff } from "src/shared/services/servicesv2";

export const useSalonData = () => {
  const [staffMembers, setStaffMembers] = useState<StylingStaff[]>([]);
  const [products, setProducts] = useState<SelectProduct[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reFresh, setReset] = useState<boolean>(false);

  const fetchStaff = async () => {
    try {
      setLoading(true);
      const response = await getStaff();
      setStaffMembers(response.data.result);
    } catch (err) {
      setError("Failed to fetch staff members");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getCategory();
      setCategories(response.data.categoryDetails);
    } catch (err) {
      setError("Failed to fetch categories");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getProduct();
      setProducts(response.data.results);
    } catch (err) {
      setError("Failed to fetch products");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔄 Refresh everything whenever reFresh changes
  useEffect(() => {
    fetchStaff();
    fetchCategories();
    fetchProducts();
  }, [reFresh]);

  // 🔁 Toggle refresh handler
  const toggleRefresh = () => setReset(prev => !prev);

  return {
    staffMembers,
    products,
    categories,
    loading,
    error,
    refetchStaff: fetchStaff,
    refetchCategories: fetchCategories,
    refetchProducts: fetchProducts,
    toggleRefresh,
  };
};

